import React, { useState } from 'react';

//COMPONENTS
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import Button from '@/main/components/shared/button/button';
import { getTranslateByKey, isEmpty, isNullUndefined } from '@/main/services/utils';

// STYLES/COMPONENTS LOCAL
import * as S from './styles';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import KOGFileUploader from '@/main/components/shared/fileUploader/fileUploader';
import { quoteApi } from '@/main/api';
import { SaveXmlPaintRequest } from '@/main/models/request';
import { useCreateOrderContext } from '@/main/screens/order/createorder/context';
import { PartSearchResponse, QuoteSelectSuppliersDataResponse, QuoteXmlResponse } from '@/main/models/response';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { loadCart } from '@/main/store/cart';

interface IModalUploadXMLProps {
  isOpenModal: boolean;
  dataPaintProject: QuoteXmlResponse | null;
  part: PartSearchResponse;
  isLoadingSave: boolean;
  selectSupplier?: QuoteSelectSuppliersDataResponse;
  setIsLoadingSave: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  closeModal: () => void;
}
function ModalUploadXML({
  isOpenModal,
  dataPaintProject,
  part,
  isLoadingSave,
  selectSupplier,
  setIsLoadingSave,
  closeModal
}: IModalUploadXMLProps) {
  const { guidQuote } = useCreateOrderContext();
  const dispatch = useDispatch();
  const [files, setFiles] = useState<File[]>([]);

  function handleClickConfirm(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();

    if (isEmpty(files)) return toast.error(getTranslateByKey('information.RequiredFile', true))
    setIsLoadingSave(true);

    const request: SaveXmlPaintRequest = {
      guidQuote: String(guidQuote),
      guidSupplier: isNullUndefined(selectSupplier) ? dataPaintProject.supplierGuid : selectSupplier.supplierGuid,
      guid: isNullUndefined(selectSupplier) ? dataPaintProject.guidQuoteSupplierItem : selectSupplier.guidQuoteSupplierItem,
      guidQuoteItem: isNullUndefined(selectSupplier) ? dataPaintProject.quoteItemGuid : selectSupplier.quoteItemGuid,
      guidSupplierInventoryWarehouse: isNullUndefined(selectSupplier) ? dataPaintProject.supplierInventory_WarehouseGuid : selectSupplier.supplierInventory_WarehouseGuid,
      idPartType: isNullUndefined(selectSupplier) ? dataPaintProject.idPartType : selectSupplier.idPartType,
      deliveryBySupplier: isNullUndefined(selectSupplier) ? dataPaintProject.deliveryBySupplier : selectSupplier.deliveryBySupplier,
      quantity: 1,
      guidPart: part.guid
    };
    quoteApi
      .saveXmlPaint(request, files[0])
      .then((response) => {
        dispatch(loadCart(String(guidQuote)));
        closeModal();
      })
      .finally(() => {
        setIsLoadingSave(false);
      })
  }
  function handleClickBack(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();
    closeModal();
  }
  return (
    <S.Container>
      <S.Title>{getTranslateByKey('information.paintPartsInfo')}</S.Title>
      <KOGFileUploader
        files={files}
        setFiles={setFiles}
        customTextDrop={getTranslateByKey('information.findFileRefinity')}
        typeFiles={'xml'}
        maxFiles={1}
        isFullScreenDragDrop
      />
      <S.AreaFooteButtons>
        <SecondaryButton
          id='id-register-btn-back'
          type='button'
          disabled={isLoadingSave}
          onClick={handleClickBack}
        >
          {getTranslateByKey('information.back')}
        </SecondaryButton>
        <SecondaryButton
          id='id-register-btn-confirm'
          type='button'
          isLoading={isLoadingSave}
          onClick={handleClickConfirm}
        >
          {getTranslateByKey('information.confirm')}
        </SecondaryButton>

      </S.AreaFooteButtons>
    </S.Container>
  )
}

function WrapperModalUploadXML(props: Omit<IModalUploadXMLProps, 'setIsLoadingSave' | 'isLoadingSave'>) {
  const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);

  const mergedProps: IModalUploadXMLProps = {
    ...props,
    isLoadingSave,
    setIsLoadingSave
  }
  return (
    <KogModalFadeComponent
      isInModal
      closeByOverlay={isLoadingSave}
      open={props.isOpenModal}
      setOpen={props.setIsOpenModal}
    >
      <ModalUploadXML {...mergedProps} />
    </KogModalFadeComponent>
  )
}

export default WrapperModalUploadXML